import EditUserFromAdminForm from './component'

export default EditUserFromAdminForm
